var exports = {
  "kL": "xe533113f--4dc44c--container",
  "vW": "xe533113f--4dc44c--inner",
  "DD": "xe533113f--4dc44c--title",
  "VA": "xe533113f--4dc44c--subtitle",
};

module.exports = exports;
